export const DeliveryMethod = {
    PICKUP: 0,
    DELIVERY: 1,
    EAT_IN: 2,
}